import { BarsOutlined, EditOutlined, FileOutlined, FolderOutlined, FormOutlined, HomeOutlined, MailOutlined, MedicineBoxOutlined, SearchOutlined, UploadOutlined, UserAddOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons';

import CreateClaimPage from 'containers/Pages/User/Claims/CreateClaim';
import CreateBatchClaimsPage from 'containers/Pages/User/Claims/CreateBatch';
import SubmittedBatchReportsPage from 'containers/Pages/User/Claims/SubmittedBatchReports';
import SearchClaimsPage from 'containers/Pages/User/Claims/SearchClaims';

import LatestDocumentsPage from 'containers/Pages/User/Documents/LatestDocuments';
import OpenAuthPage from 'containers/Pages/User/Documents/OpenAuth';
import MemoPage from 'containers/Pages/User/Documents/Memo';
import RescindNotesPage from 'containers/Pages/User/Documents/RescindNotes';
import CCSPage from 'containers/Pages/User/Documents/CCS';
import CaseDocumentsPage from 'containers/Pages/User/Documents/CaseDocuments';
import ConsultNotesPage from 'containers/Pages/User/Documents/ConsultNotes';
import MemberRosterPage from 'containers/Pages/User/Documents/MemberRoster';
import MiscPage from 'containers/Pages/User/Documents/Misc';

import RiskScorePage from 'containers/Pages/User/Hcc/RiskScore';
import GapMembersPage from 'containers/Pages/User/Hcc/GapMembers';

import QualityOverviewPage from 'containers/Pages/User/QualityOverview';

import SearchEligibilityPage from 'containers/Pages/User/Eligibility/SearchEligibility';
import MemberEligibilityInfoDetailPage from 'containers/Pages/User/Eligibility/EligibilityDetail';
import MemberRequestPage from 'containers/Pages/User/Eligibility/MemberRequest';
import CarePlanDetailPage from 'containers/Pages/User/Eligibility/CarePlanDetail';
import CareNoteDetailPage from 'containers/Pages/User/Eligibility/CareNoteDetail';
import ClaimGeneratorFinalSubmissionPage from 'containers/Pages/User/Eligibility/ClaimGenerator';

import SearchAuthPage from 'containers/Pages/User/Authorization/SearchAuthorization';
import SearchFaxAuthPage from 'containers/Pages/User/Authorization/SearchFax';
import CreateAuthorizationPage from 'containers/Pages/User/Authorization/CreateAuthorization';
import ModifyCreateAuthorizationPage from 'containers/Pages/User/Authorization/CreateAuthorization/ModifyCreateAuthorization';

import UserGuidePage from 'containers/Pages/User/Resources/UserGuide';
import ResourcesFormsPage from 'containers/Pages/User/Resources/Forms';
import NmmUpdatesPage from 'containers/Pages/User/Resources/NmmUpdates';
import EducationPage from 'containers/Pages/User/Resources/Education';
import ProviderPage from 'containers/Pages/User/Resources/Provider';

import ContactUsPage from 'containers/Pages/User/Contact/Info';
import ReportIssuesPage from 'containers/Pages/User/Contact/ReportIssues';
import CarePlansPage from 'containers/Pages/User/CaseManagement/CarePlans';
import TaskListPage from 'containers/Pages/User/CaseManagement/TaskList';
import SubmittedClaimsPage from 'containers/Pages/User/Claims/SubmittedClaims';

import UserProfilePage from 'containers/Pages/User/UserProfile';
import ChangePassword from 'containers/Pages/User/UserProfile/ChangePassword';
import AWVHMOPage from 'containers/Pages/User/AWV/HMO';
import PowerBIPage from 'containers/Pages/User/AWV/PowerBI';

/**
 * These routes contain the route "path", "component" to create the route,
 * and the "breadcrumbs" displayed on the page linked to the route.
 * If we want the breadcrumb to display, just make sure to add an array of breadcrumbs
 * containing "pathname" for the breadcrumb link and "name" for the breadcrumb to show.
 * If there's no breadcrumb to display, just create an empty breadcrumbs array
 */

// TODO: Add permissions
 export const routes = [
  {
    pathname: '/quality/overview', Component: QualityOverviewPage, name: 'Member Quick Search',
    breadcrumbs: []
  },

  {
    pathname: '/claims/create', Component: CreateClaimPage, name: 'Create Claim',
    breadcrumbs: []
  },
  {
    pathname: '/claims/submitted-claims', Component: SubmittedClaimsPage, name: 'Submitted Portal Claims',
    breadcrumbs: []
  },
  {
    pathname: '/claims/batch/submitted', Component: SubmittedBatchReportsPage, name: 'Submitted Batch Reports', category: 'claims',
    breadcrumbs: []
  },
  {
    pathname: '/claims/batch/create', Component: CreateBatchClaimsPage, name: 'Submit Batch Claims', category: 'claims',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/claims/batch/create', name: 'Batch Claims File Upload', icon: <UploadOutlined /> }
    ]
  },
  {
    pathname: '/claims/search', Component: SearchClaimsPage, name: 'Search Claims', category: 'claims',
    breadcrumbs: []
  },

  {
    pathname: '/case-mgmt/care-plans', Component: CarePlansPage, name: 'Care Plan',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/case-mgmt/care-plans', name: 'Care Plan', icon: <MedicineBoxOutlined /> }
    ]
  },
  {
    pathname: '/case-mgmt/task-list', Component: TaskListPage, name: 'Case Management Task List',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/case-mgmt/task-list', name: 'Case Management Task List', icon: <BarsOutlined /> }
    ]
  },

  {
    pathname: '/documents/new-documents', Component: LatestDocumentsPage, name: 'New Documents',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/new-documents', name: 'New Documents', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/memos', Component: MemoPage, name: 'Memos',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/memos', name: 'Memos', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/rescind-notice', Component: RescindNotesPage, name: 'Rescind Notes',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/documents/rescind-notice', name: 'Rescind Notes', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/ccs-aging', Component: CCSPage, name: 'CCS Aging Out Documents',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/documents/ccs-aging', name: 'CCS Aging Out Documents', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/case-documents', Component: CaseDocumentsPage, name: 'Case Documents',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/documents/case-documents', name: 'Case Documents', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/consult-notes', Component: ConsultNotesPage, name: 'Consult Notes',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/documents/consult-notes', name: 'Consult Notes', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/member-roster', Component: MemberRosterPage, name: 'Member Roster',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/documents/member-roster', name: 'Member Roster', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/documents/misc', Component: MiscPage, name: 'Miscellaneous',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/documents/misc', name: 'Miscellaneous', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/hcc/risk-score', Component: RiskScorePage, name: 'Providers',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/hcc/risk-score', name: 'Providers', icon: <BarsOutlined /> }
    ]
  },
  {
    pathname: '/hcc/gap-members', Component: GapMembersPage, name: 'GAP Reports',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/hcc/gap-members', name: 'GAP Reports', icon: <UserOutlined /> }
    ]
  },

  {
    pathname: '/eligibility/search',
    Component: SearchEligibilityPage,
    name: 'Member Search',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/eligibility/search', name: 'Member Search', icon: <SearchOutlined /> }
    ]
  },
  {
    pathname: '/eligibility/member-detail',
    Component: MemberEligibilityInfoDetailPage,
    name: 'Member Eligibility and Assessment',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/eligibility/search', name: 'Member Search', icon: <SearchOutlined /> },
      { pathname: '/eligibility/member-detail', name: 'Member Eligibility and Assessment', icon: <UserOutlined /> }
    ]
  },
  {
    pathname: '/eligibility/member-request', Component: MemberRequestPage, name: 'Member Request',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/eligibility/member-request', name: 'Member Request', icon: <UserAddOutlined /> },
    ]
  },
  {
    pathname: '/eligibility/pacp', Component: CarePlanDetailPage, name: 'Post Acute Care Plan',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home' },
      { pathname: '/eligibility/search', name: 'Member Search', icon: <SearchOutlined /> },
      { pathname: '/eligibility/member-detail', name: 'Member Eligibility and Assessment', icon: JSON.stringify(<UserOutlined />) },
      { pathname: '/eligibility/pacp', name: 'Post Acute Care Plan', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/eligibility/pacn', Component: CareNoteDetailPage, name: 'Post Acute Care Note',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/eligibility/search', name: 'Member Search', icon: <SearchOutlined /> },
      { pathname: '/eligibility/member-detail', name: 'Member Eligibility and Assessment', icon: <UserOutlined /> },
      { pathname: '/eligibility/pacn', name: 'Post Acute Care Note', icon: <FileOutlined /> }
    ]
  },
  {
    pathname: '/eligibility/claim-final-submission', Component: ClaimGeneratorFinalSubmissionPage, name: 'Review Claim Detail',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/eligibility/member-detail', name: 'Member Eligibility and Assessment', icon: <UserOutlined /> },
      { pathname: '/eligibility/claim-final-submission', name: 'Review Claim Detail', icon: '' }
    ]
  },

  {
    pathname: '/auth/create', Component: CreateAuthorizationPage, name: 'Create Authorization',
    breadcrumbs: []
  },
  {
    pathname: '/auth/modify-auth', Component: ModifyCreateAuthorizationPage, name: 'Modify Authorization',
    breadcrumbs: []
  },

  {
    pathname: '/auth/select-member', Component: CreateAuthorizationPage, name: 'Create Authorization',
    breadcrumbs: []
  },

  {
    pathname: '/auth/search', Component: SearchAuthPage, name: 'Select Member', category: "authorization",
    breadcrumbs: []
  },
  {
    pathname: '/auth/letter-search', Component: SearchFaxAuthPage, name: 'Auth Fax Search',
    breadcrumbs: []
  },
  {
    pathname: '/auth/open-auth', Component: OpenAuthPage, name: 'Open Auth',
    breadcrumbs: []
  },

  { pathname: '/resources/user-guide', Component: UserGuidePage, name: '', breadcrumbs: [] },
  {
    pathname: '/resources/forms', Component: ResourcesFormsPage, name: 'Forms',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/resources/forms', name: 'Forms', icon: <EditOutlined /> },
    ]
  },
  {
    pathname: '/resources/nmmupdates', Component: NmmUpdatesPage, name: 'Astrana Updates',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/resources/nmmupdates', name: 'Astrana Updates', icon: <EditOutlined /> },
    ]
  },
  {
    pathname: '/resources/edu', Component: EducationPage, name: 'Patient Resources',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/resources/edu', name: 'Patient Resources', icon: <FolderOutlined />},
    ]
  },
  {
    pathname: '/resources/provider', Component: ProviderPage, name: 'Provider Materials',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/resources/provider', name: 'Provider Materials', icon: <FolderOutlined /> },
    ]
  },

  {
    pathname: '/contact/us', Component: ContactUsPage, name: 'Contact Us',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/contact/us', name: 'Contact Us', icon: <MailOutlined /> },
    ]
  },
  {
    pathname: '/contact/report', Component: ReportIssuesPage, name: 'Report an Issue',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/contact/report', name: 'Report an Issue', icon: <WarningOutlined /> },
    ]
  },

  {
    pathname: '/account/profile', Component: UserProfilePage, name: 'User Profile',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/profile', name: 'User Profile', icon: <UserOutlined /> },
    ]
  },
  {
    pathname: '/account/change-password', Component: ChangePassword, name: 'Change User Password',
    breadcrumbs: [
      { pathname: '/quality/overview', name: 'Home', icon: <HomeOutlined /> },
      { pathname: '/account/change-password', name: 'Change User Password', icon: <FormOutlined /> },
    ]
  },
  {
    pathname: '/annual-wellness-visit', Component: AWVHMOPage, name: 'AWV',
    breadcrumbs: []
  },
  {
    pathname: '/powerbi', Component: PowerBIPage, name: 'Compensation Dashboard',
    breadcrumbs: []
  },
];